/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Ikhprof_Goethe13Inputs */

const en__field_enum_ikhprof_goethe13 = /** @type {(inputs: _Field_Enum_Ikhprof_Goethe13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prof.*in der Goethe-Universität`)
};

const de__field_enum_ikhprof_goethe13 = /** @type {(inputs: _Field_Enum_Ikhprof_Goethe13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prof.*in der Goethe-Universität`)
};

/**
* | output |
* | --- |
* | "Prof.*in der Goethe-Universität" |
*
* @param {_Field_Enum_Ikhprof_Goethe13Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_ikhprof_goethe13 = /** @type {((inputs?: _Field_Enum_Ikhprof_Goethe13Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Ikhprof_Goethe13Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_ikhprof_goethe13(inputs)
	return de__field_enum_ikhprof_goethe13(inputs)
});
export { _field_enum_ikhprof_goethe13 as "_field_enum_IKHPROF_GOETHE" }